import type { ProjectConfiguration } from '@/api/generated/model';
import { getEnabledNebulyPages } from '@/domains/pages/registry';
import type { ReportSubproduct } from '@/domains/reports/utils/report-subproduct.utils';
import type { ProjectModel } from '@/models/organizations/internal-models';

function configFromEnabledSubproducts(
  enabledSubproducts: ReportSubproduct[] | undefined,
): Pick<ProjectConfiguration, 'roi_settings' | 'aifi_settings'> {
  const enabled = new Set(enabledSubproducts ?? []);
  return {
    roi_settings: { enabled: enabled.has('roi') },
    aifi_settings: { enabled: enabled.has('aifi') },
  };
}

export function countEnabledNebulyPagesForProject(
  product: ProjectModel['product'],
  enabledSubproducts: ReportSubproduct[] | undefined,
): number {
  const config = configFromEnabledSubproducts(enabledSubproducts);
  let count = getEnabledNebulyPages('aifi', config).length;

  if (product === 'internal') {
    count += getEnabledNebulyPages('roi', config).length;
  }

  return count;
}

export function getProjectDisplayReportCount(
  project: Pick<ProjectModel, 'nReports' | 'product' | 'enabledSubproducts'>,
): number {
  return project.nReports + countEnabledNebulyPagesForProject(project.product, project.enabledSubproducts);
}
